export { default } from "./ThumbsCarouselButton";
